import * as types from '../constants/reports';
import api from '../api';

export const fetchDashGraphStart = () => {
  return {
    type: types.FETCH_DASH_GRAPH_START,
  };
};

export const fetchDashGraphSuccess = (payload) => {
  return {
    type: types.FETCH_DASH_GRAPH_SUCCESS,
    payload
  };
};

export const fetchDashGraphFailure = (err) => {
  return {
    type: types.FETCH_DASH_GRAPH_FAILURE,
    err
  };
};


export const fetchDashGraph = (payload, cb) => (dispatch) => {
  const {
    dt,
    timeZone,
    aff
  } = payload;

  dispatch(fetchDashGraphStart());

  api.get(`api.php?cmd=dashGraph&dt=${dt}&timeZone=${timeZone}&aff=${aff}`)
    .then(({ data }) => {
      const payload = data.data;
      dispatch(fetchDashGraphSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      console.log('err', err);
      dispatch(fetchDashGraphFailure(err));
    })
};

export const fetchDashTopStart = () => {
  return {
    type: types.FETCH_DASH_TOP_START
  };
};

export const fetchDashTopSuccess = (payload) => {
  return {
    type: types.FETCH_DASH_TOP_SUCCESS,
    payload
  };
};

export const fetchDashTopFailure = (err) => {
  return {
    type: types.FETCH_DASH_TOP_FAILURE,
    err
  };
};

export const fetchDashTop = (payload, cb) => (dispatch) => {
  const {
    dt,
    timeZone,
    aff,
    count
  } = payload;
  dispatch(fetchDashTopStart());

  api.get(`api.php?cmd=dashTop&dt=${dt}&timeZone=${timeZone}&aff=${aff}&count=${count}`)
    .then(({ data }) => {
      const payload = data;
      dispatch(fetchDashTopSuccess(payload));
      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      console.log('err', err);
      dispatch(fetchDashTopFailure(err));
    })
};

export const fetchDashStatsStart = () => {
  return {
    type: types.FETCH_DASH_STATS_START
  };
};

export const fetchDashStatsSuccess= (payload) => {
  return {
    type: types.FETCH_DASH_STATS_SUCCESS,
    payload
  };
};

export const fetchDashStatsFailure = (err) => {
  return {
    type: types.FETCH_DASH_STATS_FAILURE,
    err
  };
};

export const fetchDashStats = (payload) => (dispatch) => {
  const {
    dt,
    timeZone,
    aff
  } = payload;

  dispatch(fetchDashStatsStart());

  api.get(`api.php?cmd=dashStats&dt=${dt}&timeZone=${timeZone}&aff=${aff}`)
    .then(({ data }) => {
      const payload = data.data;
      dispatch(fetchDashStatsSuccess(payload));
    })
    .catch((err) => {
      dispatch(fetchDashStatsFailure(err));
    })
};

export const fetchDailyStatsStart = () => {
  return {
    type: types.FETCH_DAILY_STATS_START
  };
};

export const fetchDailyStatsSuccess = (payload) => {
  return {
    type: types.FETCH_DAILY_STATS_SUCCESS,
    payload
  };
};

export const fetchDailyStatsFailure = (err) => {
  return {
    type: types.FETCH_DAILY_STATS_FAILURE,
    err
  };
};

export const fetchDailyStats = (payload, cb) => (dispatch) => {
  const {
    dt1,
    dt2,
    timeZone,
    aff,
    saff
  } = payload;

  dispatch(fetchDailyStatsStart());

  api.get(`api.php?cmd=dailyStats&dt1=${dt1}&dt2=${dt2}&timeZone=${timeZone}&aff=${aff}&saff=${saff}`)
    .then(({ data }) => {
      const payload = data;
      dispatch(fetchDailyStatsSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchDailyStatsFailure(err));
    });
};

export const fetchHourlyStatsStart = () => {
  return {
    type: types.FETCH_HOURLY_STATS_START
  };
};

export const fetchHourlyStatsSuccess = (payload) => {
  return {
    type: types.FETCH_HOURLY_STATS_SUCCESS,
    payload
  };
};

export const fetchHourlyStatsFailure = (err) => {
  return {
    type: types.FETCH_HOURLY_STATS_FAILURE,
    err
  };
};

export const fetchHourlyStats = (payload, cb) => (dispatch) => {
  const {
    dt1,
    timeZone,
    aff,
    saff,
  } = payload;

  dispatch(fetchHourlyStatsStart());

  api.get(`api.php?cmd=hourlyStats&dt=${dt1}&timeZone=${timeZone}&aff=${aff}&saff=${saff}`)
    .then(({ data }) => {
      dispatch(fetchHourlyStatsSuccess(data));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchHourlyStatsFailure(err));
    });
};

export const fetchSubStatsStart = () => {
  return {
    type: types.FETCH_SUB_STATS_START
  };
};

export const fetchSubStatsSuccess = (payload) => {
  return {
    type: types.FETCH_SUB_STATS_SUCCESS,
    payload
  };
};

export const fetchSubStatsFailure = (err) => {
  return {
    type: types.FETCH_SUB_STATS_FAILURE,
    err
  };
};

export const fetchSubStats = (payload, cb) => (dispatch) => {
  const {
    dt1,
    dt2,
    aff,
    timeZone,
    count,
  } = payload;

  dispatch(fetchSubStatsStart());

  api.get(`api.php?cmd=subStats&dt1=${dt1}&dt2=${dt2}&timeZone=${timeZone}&aff=${aff}&count=${count}`)
    .then(({ data }) => {
      const payload = data;
      dispatch(fetchSubStatsSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchSubStatsFailure(err));
    })
};

export const fetchReferrerStatsStart = () => {
  return {
    type: types.FETCH_REFERRER_STATS_START
  };
};

export const fetchReferrerStatsSuccess = (payload) => {
  return {
    type: types.FETCH_REFERRER_STATS_SUCCESS,
    payload
  };
};

export const fetchReferrerStatsFailure = (err) => {
  return {
    type: types.FETCH_REFERRER_STATS_FAILURE,
    err
  };
};

export const fetchReferrerStats = (payload, cb) => (dispatch) => {
  const {
    dt1,
    dt2,
    aff,
    saff,
    timeZone,
    count
  } = payload;

  dispatch(fetchReferrerStatsStart());

  api.get(`api.php?cmd=refStats&dt1=${dt1}&dt2=${dt2}&timeZone=${timeZone}&aff=${aff}&saff=${saff}&count=${count}`)
    .then(({ data }) => {
      const payload = data;

      dispatch(fetchReferrerStatsSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchReferrerStatsFailure(err));
    });
};

export const fetchGeoStatsStart = () => {
  return {
    type: types.FETCH_GEO_STATS_START,
  };
};

export const fetchGeoStatsSuccess = (payload) => {
  return {
    type: types.FETCH_GEO_STATS_SUCCESS,
    payload
  };
};

export const fetchGeoStatsFailure = (err) => {
  return {
    type: types.FETCH_GEO_STATS_FAILURE,
    err
  };
};

export const fetchGeoStats = (payload, cb) => (dispatch) => {
  const {
    dt1,
    dt2,
    aff,
    saff,
    timeZone,
    count
  } = payload;

  dispatch(fetchGeoStatsStart());

  api.get(`api.php?cmd=geoStats&dt1=${dt1}&dt2=${dt2}&timeZone=${timeZone}&aff=${aff}&saff=${saff}&count=${count}`)
    .then(({ data }) => {
      const payload = data;

      dispatch(fetchGeoStatsSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchGeoStatsFailure(err));
    });
};

export const fetchClickStatsStart = () => {
  return {
    type: types.FETCH_CLICK_STATS_START
  };
};

export const fetchClickStatsSuccess = (payload) => {
  return {
    type: types.FETCH_CLICK_STATS_SUCCESS,
    payload
  };
};

export const fetchClickStatsFailure = (err) => {
  return {
    type: types.FETCH_CLICK_STATS_FAILURE,
    err
  };
};

export const fetchClickStats = (payload, cb) => (dispatch) => {
  const {
    dt1,
    dt2,
    aff,
    saff,
    timeZone,
  } = payload;

  dispatch(fetchClickStatsStart());

  api.get(`api.php?cmd=clickStats&dt1=${dt1}&dt2=${dt2}&timeZone=${timeZone}&aff=${aff}&saff=${saff}`)
    .then(({ data }) => {
      const payload = data;
      dispatch(fetchClickStatsSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchClickStatsFailure(err));
    });
};

export const fetchSaffListStart = () => {
  return {
    type: types.FETCH_SAFF_LIST_START
  };
};

export const fetchSaffListSuccess = (payload) => {
  return {
    type: types.FETCH_SAFF_LIST_SUCCESS,
    payload
  };
};

export const fetchSaffListFailure = (err) => {
  return {
    type: types.FETCH_SAFF_LIST_FAILURE,
    err
  };
};

export const fetchSaffList = (payload, cb) => (dispatch) => {
  const {
    dt1,
    dt2,
    timeZone,
    aff
  } = payload;

  dispatch(fetchSaffListStart());

  api.get(`api.php?cmd=saffList&dt1=${dt1}&dt2=${dt2 ? dt2: dt1}&timeZone=${timeZone}&aff=${aff}`)
    .then(({ data }) => {
      const payload = data.data;
      dispatch(fetchSaffListSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      console.log('err', err);
      dispatch(fetchSaffListFailure(err));
    });
};
